/**
 * Sort picker rows by numeric id descending — matches the Binom panel's
 * default sort order (newest first).
 *
 * For Media Devoted | Created By Ciro Autiero
 */

export function sortByIdDesc<T extends { id: string | number }>(rows: T[]): T[] {
  return rows
    .slice()
    .sort((a, b) => Number(b.id) - Number(a.id));
}
